<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('goldBuyCartManage.title') }}</span>
      </div>
      <div class="table-container">
        <el-table
          :data="goldBuyCartManageInfo.systemGoldSettings"
          border
          style="width: 100%"
          v-loading="loading">
          <el-table-column
            prop="busiId"
            :label="$t('goldBuyCartManage.transactionNumber')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="storeName"
            :label="$t('goldBuyCartManage.merchantName')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="amount"
            :label="$t('goldBuyCartManage.amount')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="goldCount"
            :label="$t('goldBuyCartManage.quantity')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="goldTypeName"
            :label="$t('goldBuyCartManage.goldType')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="buyerName"
            :label="$t('goldBuyCartManage.buyer')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('goldBuyCartManage.purchaseTime')"
            align="center">
          </el-table-column>
          <el-table-column
            prop="remark"
            :label="$t('goldBuyCartManage.remark')"
            align="center">
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="goldBuyCartManageInfo.total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryGoldBusiness } from '@/api/admin/goldBuyCartManage/goldBuyCartManageApi'

export default {
  name: 'GoldBuyCartManage',
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      goldBuyCartManageInfo: {
        systemGoldSettings: [],
        total: 0,
        conditions: {
          title: ''
        }
      }
    }
  },
  created() {
    this._listSystemGoldSettings(this.currentPage, this.pageSize)
  },
  methods: {
    async _listSystemGoldSettings(page, rows) {
      this.loading = true
      try {
        const params = {
          page,
          row: rows,
          ...this.goldBuyCartManageInfo.conditions
        }
        const res = await queryGoldBusiness(params)
        this.goldBuyCartManageInfo.systemGoldSettings = res.data
        this.goldBuyCartManageInfo.total = res.total
        this.goldBuyCartManageInfo.records = res.records
        console.log(this.goldBuyCartManageInfo.records)
      } catch (error) {
        console.error('获取数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listSystemGoldSettings(val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
}
.table-container {
  margin-top: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>